import React from "react";
import { useApp } from "../../context/AppProvider";

const VideoBanner = () => {
  const { setVideoModal } = useApp();

  // ID do vídeo do YouTube
  const videoId = "qIYC_jwBXpk";
  
  // URL da thumbnail do YouTube (formato padrão)
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  const handleClick = (e) => {
    e.preventDefault();
    setVideoModal(videoId);
  };

  return (
    <section className="video-banner" onClick={handleClick}>
      <div className="container">
        <div className="video-banner-content">
          <div className="video-banner-text">
            <h2>Veja como sua doação transforma vidas</h2>
            <p>Assista ao vídeo e descubra o quanto é importante doar e fazer a diferença na vida de muitas pessoas.</p>
          </div>
          <div className="video-banner-thumb">
            <img src={thumbnailUrl} alt="Vídeo sobre doação" />
            <div className="video-play-button">
              <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="50" fill="rgba(13, 150, 72, 0.85)"/>
                <circle cx="50" cy="50" r="45" fill="rgba(255, 255, 255, 0.2)" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="2"/>
                <path d="M38 30L70 50L38 70V30Z" fill="#fff"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoBanner;

